<template>
    <div>
        <div class="line__vertical-mains"></div>
        <sub-header :micrositeUrl="micrositeUrl" />
        <div v-if="locations.length > 0" class="map_filter">
            <div class="maphighlight__box">
                <h1 class="caption__select">
                    <span>Seleccione una privada, clic para ver detalles</span>
                </h1>
                <map-highlight class="canadas-map-terrenos" v-for="(img, index) in imgSet" :key="img.width" :index="index" :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :nivel="nivel" :indicators="indicators" :type="type" :locationsDisabled="disabledLocations"/>
                <Button v-for="(img, index) in imgSet" :key="img.url" :index="index" :img="img" :id="id" :nivel="nivel" :desarrollo="desarrollo" :levelId="levelId" :url="url" />
                <div class="line_horizontal"></div>
                <Availables class="availables-mobile" :amountAvailables="amountAvailables" :nivel="nivel" :url="url" />
            </div>
            <div class="select__box" :class="selectHide">
                <Select v-if="locations.length > 0 && rangeFilter.length > 0" :locations="locations" @change="changeRange" :rangeFilter="rangeFilter" />
                <Availables class="availables-desk" :amountAvailables="amountAvailables" :nivel="nivel" :url="url"/>
            </div>
        </div>
    </div>
</template>

<script>
import { locationsData } from "../../../../utils/canadas/data_disabled_canadas_casas.js"
import { mapActions, mapGetters } from "vuex";
import SubHeader from "../../../core/SubHeader.vue";
import MapHighlight from "../../../core/MapHighlight";
import Select from "../../../core/Select.vue";
import Availables from "../../../core/rediseno/Availables.vue";
import Button from "../../../core/Button.vue";
export default {
    name: "Main",
    components: {
        SubHeader,
        MapHighlight,
        Select,
        Availables,
        Button,
    },
    data() {
        return {
            id: 29,
            nivel: "towerStageLevel",
            levelId: 0,
            type: "terreno",
            desarrollo: "canadas_terrenos",
            arrFilteredLocations: [],
            url: "canads_terrenos",
            micrositeUrl: "https://www.tresmarias.com.mx/canadas/terrenos",
            imgSet: [{
                name: 'canadas_terrenos',
                url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/terrenos/MainTerrenosCanadasNv.webp',
                width: '4909',
                height: '7550',
                id: 29,
                levelId: 0,
                route: 'canads_terrenos',
                nivel: 'towerStageLevel',
                transform: '',
                viewBox: '0 0 4909 7550'
            }],
            indicators: [
                {text: 'PRIVADA 12',},
                {text: 'PRIVADA 11',},
                {text: 'PRIVADA 13',},
                { id: 154, text: 'PRIVADA 14',/*  transform: 'matrix(1.1092 0 0 1 4285.9661 6980.532)', cxB: 4220, cyB: 6950.7, rB: 55, cxW: 4220, cyW: 6950.7, rW: 25, x1: 3572.74, y1: 6842, x2: 4178.81, y2: 6938.42, status: true  */},
                { id: 210, text: 'PRIVADA 15', /* transform: 'matrix(1.1092 0 0 1 4200.9661 6500.532)', cxB: 4110, cyB: 6440.7, rB: 55, cxW: 4110, cyW: 6440.7, rW: 25, x1: 4084.42, y1: 6409.95, x2: 3653.44, y2: 5980.03, status: true  */},
                { id: 211, text: 'PRIVADA 22', /* transform: 'matrix(1.1092 0 0 1 150.6289 4000.8673)', cxB: 905.6, cyB: 3960.8, rB: 55, cxW: 905.6, cyW: 3960.8, rW: 25, x1: 951.45, y1: 3950.95, x2: 1433.81, y2: 3827.49, status: true  */},
                { id: 237, text: 'PRIVADA 28', transform: 'matrix(1.1092 0 0 1 4050.9661 7030.532)', cxB: 3970, cyB: 6980.7, rB: 55, cxW: 3970, cyW: 6980.7, rW: 25, x1: 3932.63, y1: 6953.77, x2: 3410.68, y2: 6511.44, status: true },
            ],
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false,
            disabledLocations:locationsData,
        };
    },

    computed: {
        ...mapGetters({
            locations: "getLocations",
        }),
        development() {
            return { id: this.id, level: 0 };
        },
        existFilter() {
            let arrExistFilter;
            if (this.rangeFilter) {
                arrExistFilter = this.arrFilteredLocations;
            } else if (this.rangeFilter === false) {
                arrExistFilter = this.locations;
            }
            return arrExistFilter;
        }, 
        returnAvailable() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.available > 0
            );
            return newArrfiltered;
        },
        amountAvailables() {
            return this.returnAvailable.filter(function(location) {
                return location.id == 211 || location.id == 210 || location.id == 154 || location.id == 237;
            });
        },

        selectHide() {
            if (this.rangeFilter == false) {
                return 'u__dipslay--none'
            } else {
                return ''
            }
        }
    },
    methods: {
        ...mapActions(["getTowerStageLevels", "clearCoords"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
    },
    async created() {
        await this.clearCoords();
        await this.getTowerStageLevels(this.development);
    },
    async beforeDestroy() {
        await this.clearCoords()
    },
};
</script>
